export const SENTIMENT_OPTIONS = [
    { label: "Positive", value: "positive" },
    { label: "Negative", value: "negative" },
    { label: "Caution", value: "caution" },
    { label: "Neutral", value: "neutral" },
];
